import React from 'react';
import styled from 'styled-components';
import TeamChartBody from './TeamChartBody';
import TeamChartHeader from './TeamChartHeader';

const Wrapper = styled.div`
  border: 1px solid #CECECE;
  .table-body:nth-last-child(2){
    .table-body-row{
      .other-side{
        .line-for-chart{
          height: 58%;
        }
      }
    }
  }
  /* .empty-div{
    display: none;
  } */
`;
const TeamChartWrapper = function TeamChartWrapper() {
  return (
    <Wrapper className="table-container">
      <TeamChartHeader />
      <TeamChartBody />
    </Wrapper>
  );
};

export default TeamChartWrapper;
